import get from 'lodash/get';

import {
  CREATE_REDESIGN_REQUEST,
  DELETE_REDESIGN_REQUEST,
  UPDATE_REDESIGN_REQUEST,
  SELECT_REDESIGN_REQUEST,
  SET_SELECTED_NAV_TAB
} from './actions';

export const initialState = {
  isRedesignRequestsOpen: false,
  selectedRedesignRequest: null,
  redesignRequests: {},
  selectedNavTab: 0
};

export const studioRedesignRequestsReducerKey = 'studioRedesignRequests';

export const studioRedesignRequestsReducer = (state = initialState, { type = '', payload = {} } = {}) => {
  switch (type) {
    case SET_SELECTED_NAV_TAB:
      return {
        ...state,
        selectedNavTab: payload.selectedNavTab
      };
    case CREATE_REDESIGN_REQUEST:
      return {
        ...state,
        redesignRequests: {
          ...state.redesignRequests,
          [payload.redesignRequest.id()]: payload.redesignRequest
        }
      };
    case DELETE_REDESIGN_REQUEST:
      const { [payload.id]: deletedRedesignRequest, ...remaining } = state.redesignRequests;
      return {
        ...state,
        redesignRequests: remaining,
        selectedRedesignRequest: state.selectedRedesignRequest === payload.id ? null : state.selectedRedesignRequest
      };
    case SELECT_REDESIGN_REQUEST:
      return {
        ...state,
        selectedRedesignRequest: payload.id
      };
    case UPDATE_REDESIGN_REQUEST:
      const redesignRequest = get(state, `redesignRequests.${payload.id}`);
      if (!redesignRequest || !redesignRequest.makeCopy) {
        return state;
      }
      return {
        ...state,
        redesignRequests: {
          ...state.redesignRequests,
          [payload.id]: redesignRequest.makeCopy({ ...payload.updateData })
        }
      };
    default:
      return state;
  }
};
